import React, { useState, useEffect, useRef } from "react";
import { useSite } from "../../context/site";
import SwitchControl from "../../components/site/SwitchControl";
import { ArrowField } from "../../components/site/motion";

export const Splash = ({ onEnter }) => {
  const { openTalk } = useSite();
  const [on, setOn] = useState(false);
  const t = useRef();
  const goTalk = () => { onEnter(); setTimeout(() => openTalk(), 80); };
  useEffect(() => () => clearTimeout(t.current), []);
  const flip = () => {
    if (on) return;
    setOn(true);
    t.current = setTimeout(onEnter, 340);
  };
  return (
    <div data-testid="home-splash" className="fixed inset-0 z-[100] overflow-hidden bg-[#161A15]">
      <div aria-hidden className="pointer-events-none absolute inset-y-0 right-0 hidden w-[42%] lg:block">
        <ArrowField active={on} className="h-full w-full" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(90deg,#161A15 0%, rgba(22,26,21,0.55) 26%, rgba(22,26,21,0) 62%)" }} />
      </div>

      <div className="relative z-10 flex h-full flex-col px-8 py-10 md:px-14 md:py-14 lg:px-16">
        <div className="flex items-center justify-between border-b border-white/15 pb-6">
          <img src="/assets/wordmark.png" alt="SWITCH" className="h-7 w-auto brightness-0 invert md:h-8" />
          <span className="font-body hidden text-xs font-semibold uppercase tracking-[0.24em] text-white/55 sm:inline">Growth, switched on</span>
        </div>

        <div className="flex flex-1 flex-col justify-center">
          <div className="max-w-2xl">
            <h1 className="font-display text-5xl leading-[1.02] tracking-tight text-white sm:text-6xl md:text-7xl lg:text-8xl">
              Everyone is working.
              <br />
              <span className={on ? "text-[#5f8f10]" : "text-white/40"}>Growth </span>
              <span className={on ? "text-[#5f8f10]" : "text-white/40"}>{on ? "is." : "isn\u2019t."}</span>
            </h1>

            <p className="font-body mt-8 max-w-xl text-lg font-normal leading-relaxed text-white/80" data-testid="home-splash-clarity">
              We find what&rsquo;s holding growth back, build the strategy to fix it, and stay to execute it.
            </p>

            <div className="mt-8">
              <button
                type="button"
                onClick={goTalk}
                data-testid="home-splash-cta"
                className="font-body inline-flex items-center gap-3 rounded-full bg-[#5f8f10] px-7 py-4 text-sm font-semibold uppercase tracking-[0.14em] text-[#0f1408] transition-colors duration-200 hover:bg-[#6ea513]"
              >
                Bring us your growth problem
                <span aria-hidden>&rarr;</span>
              </button>
            </div>

            {/* the switch, kept as a deliberate interaction (secondary to the value + CTA above) */}
            <div className="mt-12 inline-flex items-center gap-5" data-testid="home-splash-switch">
              <SwitchControl active={on} onToggle={flip} size="lg" tone="dark" ariaLabel="Flip the switch to enter" testId="home-splash-toggle" />
              <button
                type="button"
                onClick={flip}
                data-testid="home-splash-enter"
                className="group flex flex-col items-start text-left"
              >
                <span className="font-body text-sm font-semibold uppercase tracking-[0.16em] text-white transition-colors group-hover:text-[#5f8f10]">Flip the switch.</span>
                <span className="font-body mt-1 inline-flex items-center gap-2 text-xs font-normal uppercase tracking-[0.16em] text-white/55">
                  Turn growth on
                  <span aria-hidden className="text-[#5f8f10] transition-transform duration-200 group-hover:translate-x-1">→</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

